import { render, staticRenderFns } from "./SearchListItem.vue?vue&type=template&id=08baff14&scoped=true"
import script from "./SearchListItem.vue?vue&type=script&lang=js"
export * from "./SearchListItem.vue?vue&type=script&lang=js"
import style0 from "./SearchListItem.vue?vue&type=style&index=0&id=08baff14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08baff14",
  null
  
)

export default component.exports